import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import uniq from 'lodash/uniq';
import isEmpty from 'lodash/isEmpty';

import KDSCombobox from '@decisiv/ui-components/lib/components/Combobox';

const Combobox = ({ name, defaultValue, options, disabled, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleChange = (currentValue, id, removed, onChange) => {
    const value = removed
      ? [...currentValue?.filter((currId) => currId !== id)]
      : uniq([...currentValue, id]);

    onChange(value);
  };

  const comboboxValue = (currentValue) => {
    return currentValue?.map((currVal) =>
      options.find((option) => option.value === currVal),
    );
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <KDSCombobox
          value={comboboxValue(value)}
          options={options}
          multiple
          disabled={disabled || isEmpty(options)}
          onChangeValue={(id, { removed }) =>
            handleChange(value, id, removed, onChange)
          }
          warningMessage={errors[name]?.message?.toString()}
          {...props}
        />
      )}
    />
  );
};

Combobox.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.bool,
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
};

Combobox.defaultProps = {
  defaultValue: [],
  disabled: false,
};

export default Combobox;
